import { useEffect, useState } from 'react';
import axios from 'axios';
import { getGameType } from '../../../variables/gameTypes';
import { GRID_TYPE_PREVIEWS, NumberGridPreview } from './gridTypePreviews';

// block.grid already arrives with {id, type, name, dAdd, dMod} embedded
// (same as block.conversation for embed_conversation) - only the content
// itself (GridCard[]) needs its own fetch, same call GameCardsEditor.jsx
// already uses for the admin edit view.
export default function EmbedGridPreview({ block }) {
   const grid = block.grid;
   const gridId = grid ? grid.id : null;
   const [cards, setCards] = useState(null);

   useEffect(() => {
      if(!gridId) {
         setCards([]);
         return;
      }
      axios.get('/api/gridcard?grid=' + gridId, { withCredentials: true })
         .then(response => setCards(Array.isArray(response.data) ? response.data : []))
         .catch(() => setCards([]));
   }, [gridId]);

   if(!grid) return <span className='exercise-block-empty-hint'>Гру не обрано</span>;
   if(cards === null) return <span className='exercise-block-empty-hint'>Завантаження...</span>;

   const gameType = getGameType(grid.type);
   const TypePreview = GRID_TYPE_PREVIEWS[grid.type] || NumberGridPreview;

   return (
      <div className='course-preview-embed-grid'>
         <div className='course-preview-embed-grid-header'>
            <span className='course-preview-embed-grid-badge' style={{ '--accent': gameType.accent }}>{gameType.label}</span>
         </div>
         {cards.length === 0 ? (
            <span className='exercise-block-empty-hint'>Гра порожня</span>
         ) : (
            <TypePreview cards={cards} />
         )}
      </div>
   );
}
